import React from 'react'
import { Text, Box, Link } from '@revolut/ui-kit'
import { notReachable } from 'helpers/notReachable'
import { OPEN_BANKING_REGION } from 'types/common'
import type { OpenBankingRegion } from 'types/common'

const AU_HELP_URL = 'https://help.revolut.com/en-AU/help/more/'
const GEO_REDIRECT_HELP_URL =
  'https://www.revolut.com/help/more/legal-topics/which-revolut-companies-provide-me-with-services?geo-redirect=true'

type LegalFooterProps = {
  openBankingRegion: OpenBankingRegion
}

const getHelpPageUrl = (openBankingRegion: OpenBankingRegion): string => {
  switch (openBankingRegion) {
    case OPEN_BANKING_REGION.AU:
      return AU_HELP_URL
    case OPEN_BANKING_REGION.OTHER:
      return GEO_REDIRECT_HELP_URL
    default:
      return notReachable(openBankingRegion)
  }
}

export const LegalFooter = ({ openBankingRegion }: LegalFooterProps) => {
  const webURL = (
    <Link
      href={getHelpPageUrl(openBankingRegion)}
      rel='noopener noreferrer'
      target='_blank'
    >
      our help page
    </Link>
  )

  return (
    <Box use='footer'>
      <Text
        use='div'
        mt='s-32'
        mb='s-16'
        color='grey-tone-50'
        textAlign='center'
        variant='small'
      >
        Sign in to your Revolut account. The payment or account information request will
        be initiated by the Revolut entity with which you have your account. If you’d like
        to find out more about which Revolut entity you receive services from, or if you
        have any other questions, get in touch using our in-app chat feature. You can also
        get more info on {webURL}.
      </Text>
    </Box>
  )
}
